export const SITE_NAME = 'Nexhance AI';
export const SITE_DOMAIN = 'nexhanceai.com';
export const SITE_TAGLINE = 'Professional AI image enhancement with natural-looking results.';
export const CANONICAL_SITE_ORIGIN = 'https://nexhanceai.com';

function normalizeSiteOrigin(value: string) {
  const origin = value.trim().replace(/\/$/, '');
  if (/^https?:\/\/(?:www\.)?nexhanceai\.com$/i.test(origin)) return CANONICAL_SITE_ORIGIN;
  return origin;
}

export function getSiteUrl() {
  const configured = normalizeSiteOrigin(String(import.meta.env.VITE_SITE_URL ?? ''));
  if (configured) return configured;
  return CANONICAL_SITE_ORIGIN;
}

export function absoluteUrl(path = '/') {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  const base = getSiteUrl();
  return normalized === '/' ? `${base}/` : `${base}${normalized}`;
}
